export class VinhubChat {
  id: number;
  participants: ParticipantsModel[];
  type: string;
  reference: string;
  lastMessage: VinhubMessage;
  unreadMessages: number;
  activeConversation?: boolean;
}

export class ParticipantsModel {
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  userId: string;
}

export class VinhubChatMessages {
  messages: VinhubMessage[];
  nextToken: string;
}

export class VinhubMessage {
  id: number;
  chatId: number;
  message: string;
  attachments: VinhubAttachment[];
  attachmentSize: number | null;
  videoId: number | null;
  authorId: string;
  source: 'USER' | 'SYSTEM' | 'ADVICE' | 'INSIGN' | 'ACCOUNT' | 'ABSENCE' | 'OPENING_HOURS';
  createdAt: string;
  dateLabel: string;
  readBy: string[];
  repliedTo?: VinhubRepliedToMessage;
  link?: VinhubMessageLink;
  /** Set once the author edited the text (PATCH /chat/b2b/message/{chatId}/{messageId}) */
  editedAt?: string | null;
}

export class VinhubRepliedToMessage {
  id: number;
  authorId: string;
  message: string | null;
  attachmentType: 'IMAGE' | 'PDF' | 'OTHER' | null;
  attachmentFilename: string | null;
  hasVideo: boolean;
  source: 'USER' | 'SYSTEM' | 'ADVICE' | 'INSIGN' | 'ACCOUNT' | 'ABSENCE' | 'OPENING_HOURS';
}

export class VinhubAttachment {
  id: number;
  type: 'IMAGE' | 'PDF' | 'OTHER';
  filename: string;
  filesize: number;
  fileUrl: string;
  previewUrl: string;
}

export class VinhubAttachmentForSend {
  type: string;
  filename: string;
  filesize: number;
}

export class ReadMessages {
  chatId: number;
  messageIds: number[];
  readBy: string;
}

export class VinhubMessageLink {
  name: string = null;
  url: string = null;
}
